import React from "react";
import {
  Typography,
  Card,
  Table,
  Alert,
  Space,
  Divider,
  List,
  Tabs,
} from "antd";
import {
  LoginOutlined,
  SafetyOutlined,
  FormOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import AdminPageLayout from "./layout/AdminPageLayout";

const { Title, Paragraph, Text, Link } = Typography;

const Alloggiati = () => {
  // Data for the code table
  const codeTableColumns = [
    {
      title: "Gruppo",
      dataIndex: "group",
      key: "group",
      width: "40%",
    },
    {
      title: "Codice",
      dataIndex: "code",
      key: "code",
      width: "60%",
    },
  ];

  const codeTableData = [
    { key: "1", group: "Gruppo 1", code: "7467" },
    { key: "2", group: "Gruppo 2", code: "4655" },
    { key: "3", group: "Gruppo 3", code: "5760" },
    { key: "4", group: "Gruppo 4", code: "0677" },
    { key: "5", group: "Gruppo 5", code: "2985" },
    { key: "6", group: "Gruppo 6", code: "0332" },
    { key: "7", group: "Gruppo 7", code: "5076" },
    { key: "8", group: "Gruppo 8", code: "2976" },
    { key: "9", group: "Gruppo 9", code: "4643" },
    { key: "10", group: "Gruppo 10", code: "8464" },
    { key: "11", group: "Gruppo 11", code: "1993" },
    { key: "12", group: "Gruppo 12", code: "0916" },
    { key: "13", group: "Gruppo 13", code: "4887" },
    { key: "14", group: "Gruppo 14", code: "8799" },
    { key: "15", group: "Gruppo 15", code: "3478" },
    { key: "16", group: "Gruppo 16", code: "9033" },
  ];

  // Required fields for the form
  const requiredFields = [
    {
      label: "Tipo",
      description:
        "Tipologia di alloggiato (es. Ospite singolo, Capofamiglia, ecc)",
    },
    { label: "Data di Arrivo", description: "Data di check-in" },
    { label: "Permanenza", description: "Durata del soggiorno (1-30 giorni)" },
    { label: "Cittadinanza", description: "Nazionalità dell'ospite" },
    { label: "Luogo di Nascita", description: "Città di nascita" },
    { label: "Cognome", description: "Cognome dell'ospite" },
    { label: "Nome", description: "Nome dell'ospite" },
    { label: "Data di Nascita", description: "Data di nascita" },
    { label: "Sesso", description: "Genere (M/F)" },
    {
      label: "Luogo di Rilascio Documento",
      description: "Dove è stato rilasciato il documento",
    },
    {
      label: "Tipo Documento",
      description:
        "Tipo di documento d'identità (es. Carta d'identità, Passaporto)",
    },
    {
      label: "Numero Documento",
      description: "Numero identificativo del documento",
    },
  ];

  return (
    <AdminPageLayout
      title="Alloggiati Web"
      icon={<FormOutlined />}
      subtitle="Guida passo-passo per la comunicazione degli alloggiati alla Polizia di Stato"
    >
      <Alert
        message="Importante"
        description={
          <Paragraph style={{ margin: 0 }}>
            <Text strong>
              Si ribadisce che i gestori di strutture ricettive di ogni genere o
              tipologia hanno l'obbligo di comunicare le generalità degli
              alloggiati rilevate dalla carta di identità (o altro documento di
              identificazione). Pertanto al fine di verificare tale
              corrispondenza, non sono consentite forme di check in a distanza o
              da remoto ovvero mediante strumenti telematici o elettronici o
              piattaforme social. Le generalità - rilevate sul posto dal
              documento di identità - dovranno poi essere comunicate tramite il
              portale alloggiati web secondo le modalità indicate dal decreto
              del ministro dell'interno del 7 gennaio 2013, come modificato dal
              decreto del ministro dell'interno del 16 settembre 2021.
            </Text>
          </Paragraph>
        }
        type="warning"
        showIcon
      />
      <Card style={{ marginTop: 24 }}>
        <Tabs
          defaultActiveKey="1"
          items={[
            {
              key: "1",
              label: (
                <span>
                  <LoginOutlined /> 1. Accedi al portale
                </span>
              ),
              children: (
                <Space direction="vertical" size="middle">
                  <Paragraph>
                    Effettua il login presso:{" "}
                    <Link
                      href="https://alloggiatiweb.poliziadistato.it/AlloggiatiWeb/Inserimento_Step1.aspx"
                      target="_blank"
                    >
                      https://alloggiatiweb.poliziadistato.it/AlloggiatiWeb/Inserimento_Step1.aspx
                    </Link>
                  </Paragraph>
                  <Card
                    size="small"
                    style={{ maxWidth: 500 }}
                    title="Credenziali di accesso"
                  >
                    <Text strong>USER:</Text> SO004377
                    <br />
                    <Text strong>PASSWORD:</Text> bQ6B15GF
                  </Card>
                </Space>
              ),
            },
            {
              key: "2",
              label: (
                <span>
                  <SafetyOutlined /> 2. Inserisci i codici
                </span>
              ),
              children: (
                <Space direction="vertical" size="middle">
                  <Paragraph>
                    Effettuato l'accesso, il sistema mostrerà un tastierino
                    numerico per l'inserimento e la verifica dei codici
                    dispositivi. L'utente ha una scheda codici nella quale sono
                    presenti 16 gruppi di codici e ogni gruppo è formato da una
                    stringa di 4 numeri. Il sistema indicherà, tramite una
                    generazione casuale, quale numero della stringa di un
                    determinato gruppo di codici inserire nei riquadri bianchi.
                  </Paragraph>
                  <Card
                    size="small"
                    style={{ maxWidth: 600 }}
                    title="Tabella dei Codici Dispositivi"
                  >
                    <Table
                      columns={codeTableColumns}
                      dataSource={codeTableData}
                      pagination={false}
                      size="small"
                      bordered
                    />
                  </Card>
                </Space>
              ),
            },
            {
              key: "3",
              label: (
                <span>
                  <FormOutlined /> 3. Inserisci i dati
                </span>
              ),
              children: (
                <Space direction="vertical" size="middle">
                  <Paragraph>
                    Dopo la verifica dei codici, procedi con l'inserimento dei
                    dati degli alloggiati secondo le indicazioni fornite dal
                    sistema. Per ogni ospite è necessario inserire i seguenti
                    dati, ricavati direttamente dal documento d'identità:
                  </Paragraph>

                  <Card
                    size="small"
                    style={{ maxWidth: 700 }}
                    title={
                      <Space>
                        <InfoCircleOutlined />
                        <span>
                          Campi richiesti per l'inserimento degli alloggiati
                        </span>
                      </Space>
                    }
                  >
                    <List
                      size="small"
                      bordered
                      dataSource={requiredFields}
                      renderItem={(item) => (
                        <List.Item>
                          <Text strong>{item.label}:</Text> {item.description}
                        </List.Item>
                      )}
                    />
                  </Card>

                  <Alert
                    type="info"
                    message="Nota"
                    description="Tutti i dati devono essere inseriti esattamente come riportati sul documento d'identità originale. In caso di discrepanze, il sistema potrebbe rifiutare la comunicazione."
                    showIcon
                  />
                </Space>
              ),
            },
          ]}
        />
      </Card>
    </AdminPageLayout>
  );
};

export default Alloggiati;
